'use strict';

export function langPath(path) {
    const lang = typeof window !== 'undefined' ? window.LANG : context.appContext.config.lang;

    if (lang === 'ua' && path.indexOf('/ua/') === -1) {
        path = `/ua/${path}`;
    }

    path = path.replace('//', '/');

    return path;
}
